import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '@tech-environments/environment';
import {
  UntypedFormGroup,
  FormControl,
  Validators,
  UntypedFormBuilder,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IconDefinition, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { AppConfig } from '@tech-utils/app-config.service';
import { OnExecuteData, ReCaptchaV3Service } from 'ng-recaptcha';
import { Subject, Subscription } from 'rxjs';
import { OnboardingcoreService } from '@tech-services/onboardingcore.service';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '@tech-services/common.service';
import { SessionService } from '@tech-services/session.service';
import { TechDialogsService } from '../../shared/tech-dialogs.service';

@Component({
  selector: 'tech-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  public logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  public form: UntypedFormGroup;
  public hide = true;
  public faSpinner: IconDefinition = null;
  public showfaSpinner: boolean = false;
  public errorMinLength: boolean = true;
  public errorUpcase: boolean = true;
  public errorDowncase: boolean = true;
  public errorDigi: boolean = true;
  public errorChart: boolean = true;
  public errorRealMail: boolean = true;
  public regex: string =
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+=,."-¬¡><])[A-Za-z\\d!@#$%^&*()_+=,."-¬¡><]+$';
  public regexUpcase: string = '^(?=.*[A-Z])';
  public regexDowncase: string = '^(?=.*[a-z])';
  public regexDigi: string = '^(?=.*[0-9].*)';
  public regexChart: string = '^(?=.*[!@#$%^&*()_+=,."><¬¡-])';
  public recaptchaToken: string = '';
  public recaptchaSitekey: string = AppConfig.settings.reCaptchaKey;
  public mailExist: boolean = false;
  private captchatoken: string;
  public consent: string;

  constructor(
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private recaptchaV3Service: ReCaptchaV3Service,
    public onboardingCoreService: OnboardingcoreService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private commonService: CommonService,
    private techDialogsService: TechDialogsService,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('language') != null) {
      this.translate.setDefaultLang(
        this.route.snapshot.paramMap.get('language')
      );
      this.translate.use(this.route.snapshot.paramMap.get('language'));
      this.sessionService.language =
        this.route.snapshot.paramMap.get('language');
      localStorage.setItem(
        'Language',
        this.route.snapshot.paramMap.get('language')
      );
    } else {
      this.sessionService.language = localStorage.getItem('Language');
      this.translate.use(localStorage.getItem('Language'));
    }
    localStorage.removeItem('ClientCode');
    this.sessionService.clientCode = '';
    localStorage.removeItem('portfolioCode');
    this.sessionService.portfolioCode = '';
    localStorage.removeItem('ClientId');
    this.sessionService.clientId = '';
    localStorage.removeItem('SessionClientToken');
    this.sessionService.sessionToken = '';

    this.translate.get('k002514').subscribe((text: string) => {
      this.commonService.setTitle(text + ' | ' + AppConfig.settings.tabTitle);
    });
    // this.form.statusChanges.subscribe((result) => this.formValidation());

    // this.translate.get('k002462').subscribe((text: string) => {
    //   this.consent = text.replace('{0}', AppConfig.settings.entityName);
    // });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
